import SubscriptionType from '../constants/subscription-type';

function isDomainPackageType(type: string): boolean {
  return type === SubscriptionType.DOMAIN_SUBSCRIPTION;
}

export default isDomainPackageType;
